// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__z62RO","location":"Header_location__10tuW"};